import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1',

    [theme.breakpoints.down('md')]: {
      marginRight: '1rem'
    }
  },

  gridRoot: {
    gridColumn: '3 / 4',
    overflow: 'hidden'
  },

  contentBlock: {
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      width: '98%'
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2px',
    marginTop: '0.5rem'
  },

  boldedName: {
    // Both rules are needed because sometimes we have a div inside the name
    '& .Content-name': {
      fontWeight: `${theme.bold.bold} !important`
    },

    '& .Content-name > *': {
      fontWeight: `${theme.bold.bold} !important`
    }
  },

  boldedContent: {
    fontWeight: `${theme.bold.bold} !important`
  },

  name: {
    overflow: 'hidden',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#323436'
  },

  time: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '0.25rem',
    fontSize: theme.size.sm,
    textAlign: 'right',
    color: '#323436'
  },

  content: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: '40px',
    color: '#7F8487',
    fontSize: theme.size.xs,
    marginTop: '4px'
  },

  controlsBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    margin: '7px 0.25rem',

    '& .icon': {
      cursor: 'default',
      color: theme.palette.primary.main
    },

    '& .button': {
      color: '#323436',
      cursor: 'pointer'
    }
  },

  faded: {
    opacity: '0.35'
  },

  group: {
    display: 'flex',
    opacity: '0.35',
    paddingLeft: '0.25rem'
  }
}))

export default useStyles
